import AddressCoordinatesTab from 'features/user/components/add-edit-address/AddressCoordinatesTab';
import AddressAttachmentsTab from 'features/user/components/add-edit-address/AddressAttachmentsTab';
import AddressZonesTab from 'features/user/components/add-edit-address/AddressZonesTab';
import AddressSopsTab from 'features/user/components/add-edit-address/AddressSopsTab';
import AddressPartiesTab from 'features/user/components/add-edit-address/AddressPartiesTab';
import AddressPrePlanTab from 'features/user/components/add-edit-address/AddressPrePlanTab';
import AddressHistoryTab from 'features/user/components/add-edit-address/AddressHistoryTab';
import AddressDetailsForm from 'features/user/components/add-edit-address/AddressDetailsForm';

export const AddressMenuItemKey = {
  EDIT_ADDRESS: 'edit-address',
  ATTACHMENTS: 'attachments',
  COORDINATES: 'coordinates',
  HISTORY: 'history',
  PARTIES: 'parties',
  PRE_PLAN: 'pre-plan',
  SOPS: 'sops',
  ZONES: 'zones',
};

export const EDITABLE_ADDRESS_MENU_KEYS = new Set([
  AddressMenuItemKey.EDIT_ADDRESS,
  AddressMenuItemKey.COORDINATES,
  AddressMenuItemKey.PRE_PLAN,
]);

export const AddressSideBarMenuItem = [
  { key: AddressMenuItemKey.EDIT_ADDRESS, label: 'Edit Address', content: AddressDetailsForm },
  { key: AddressMenuItemKey.ATTACHMENTS, label: 'Attachments', content: AddressAttachmentsTab },
  { key: AddressMenuItemKey.COORDINATES, label: 'Coordinates', content: AddressCoordinatesTab },
  { key: AddressMenuItemKey.HISTORY, label: 'History', content: AddressHistoryTab },
  { key: AddressMenuItemKey.PARTIES, label: 'Parties', content: AddressPartiesTab },
  { key: AddressMenuItemKey.PRE_PLAN, label: 'Pre-Plan', content: AddressPrePlanTab },
  { key: AddressMenuItemKey.SOPS, label: 'SOPS', content: AddressSopsTab },
  { key: AddressMenuItemKey.ZONES, label: 'Zones', content: AddressZonesTab },
];

export const getSelectedAddressMenu = (key) =>
  AddressSideBarMenuItem.find((item) => item.key === key) || null;

export const AddressSidebarGroups = [
  { key: 'address', label: 'Address', items: AddressSideBarMenuItem },
];
